import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IModalBase, initialDataList } from '../../interfaces/commonInterfaces'
import moment from 'moment'

export interface UserState {
  responseLogin?: { loading: boolean; error: boolean; response?: unknown }
  userList: unknown
  userOptionList?: unknown
  userDetail?: unknown
  reloadUserList?: string | null
  modalUser?: IModalBase
}

const initialState: UserState = {
  userList: initialDataList,
  userOptionList: initialDataList,
  userDetail: {},
  reloadUserList: null,
  modalUser: {
    visible: false,
    record: {},
  },
}

export const userDucks = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state) => {
      state.responseLogin = { loading: true, error: false }
    },
    loginSuccess: (state, action: PayloadAction<unknown>) => {
      state.responseLogin = {
        loading: false,
        error: false,
        response: action.payload,
      }
    },
    loginFail: (state, action: PayloadAction<unknown>) => {
      state.responseLogin = {
        loading: false,
        error: true,
        response: action.payload,
      }
    },

    getListUser: (state, action: PayloadAction<string | undefined>) => {
      state.userList = { loading: true, queryStr: action.payload }
    },
    getListUserSuccess: (state, action: PayloadAction<unknown>) => {
      state.userList = { loading: false, ...(action.payload as object) }
    },
    getListUserFail: (state, action: PayloadAction<unknown>) => {
      state.userList = { loading: false, ...(action.payload as object) }
    },

    getListOptionUser: (state) => {
      // Giữ data cũ khi refetch để select không nhảy về ID thô trong lúc loading
      state.userOptionList = { ...(state.userOptionList as Record<string, unknown>), loading: true }
    },
    getListOptionUserSuccess: (state, action: PayloadAction<unknown>) => {
      state.userOptionList = { loading: false, ...(action.payload as object) }
    },
    getListOptionUserFail: (state, action: PayloadAction<unknown>) => {
      state.userOptionList = { loading: false, ...(action.payload as object) }
    },

    getDetailUser: (state, action: PayloadAction<string | number>) => {
      state.userDetail = { loading: true, id: action.payload }
    },
    getDetailUserSuccess: (state, action: PayloadAction<unknown>) => {
      state.userDetail = { loading: false, ...(action.payload as object) }
    },
    getDetailUserFail: (state, action: PayloadAction<unknown>) => {
      state.userDetail = { loading: false, ...(action.payload as object) }
    },

    setReloadUserList: (state) => {
      state.reloadUserList = String(moment())
    },
    setModalUser: (state, action: PayloadAction<IModalBase>) => {
      state.modalUser = action.payload
    },
  },
})

export const {
  login,
  loginSuccess,
  loginFail,
  getListUser,
  getListUserSuccess,
  getListUserFail,
  getListOptionUser,
  getListOptionUserSuccess,
  getListOptionUserFail,
  getDetailUser,
  getDetailUserSuccess,
  getDetailUserFail,
  setReloadUserList,
  setModalUser,
} = userDucks.actions

export default userDucks.reducer
